import React from 'react';
import LoginForm from "../app/components/Login/LoginForm";

const Login = () => {
    return (
        <div className="flex flex-col items-center p-4">
            <LoginForm />
        </div>
    );
};

export default Login;
